import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PhotoboothClientAreaComponent } from './layout.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HeaderComponent } from './components/header/header.component';

@NgModule({
    declarations: [
        PhotoboothClientAreaComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        SidebarComponent,
        HeaderComponent
    ],
    exports: [
        PhotoboothClientAreaComponent
    ]
})
export class PhotoboothLayoutModule
{
}
